import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

import { ProfessionService } from 'src/app/shared/services/profession.service';
import {
  deleteProfession,
  editProfession,
  loadProfession,
  loadProfessionFilter,
  loadProfessionSuccess,
  saveProfession,
} from './profession.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class ProfessionEffects {
  constructor(private service: ProfessionService, private action$: Actions, private notify: NotifyService) {}

  loadProfession$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadProfessionFilter,loadProfession),
      exhaustMap((params : any) =>
        this.service
          .getAll(params?.professionCategory?.toString())
          .pipe(
            map((res) => loadProfessionSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveProfession$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveProfession),
      concatMap(({ profession }) =>
        this.service.save(profession).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadProfession()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editProfession$ = createEffect(() =>
    this.action$.pipe(
      ofType(editProfession),
      concatMap(({ profession, id }) =>
        this.service.edit(profession, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadProfession()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteProfession$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteProfession),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadProfession()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
